import { render, staticRenderFns } from "./historyMail.vue?vue&type=template&id=b25ccb52&scoped=true&"
import script from "./historyMail.vue?vue&type=script&lang=js&"
export * from "./historyMail.vue?vue&type=script&lang=js&"
import style0 from "./historyMail.vue?vue&type=style&index=0&id=b25ccb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25ccb52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
